import './App.css'
import { AnimatePresence, motion } from 'framer-motion'
import Nav from './Components/Nav'
import { useState } from 'react'


function App() {
  let [inputs, setInputs] = useState([''])
  let [choice, setChoice] = useState(null)
  let [msg, setMsg] = useState('')

  function handleChange(e, index) {
    let clone = [...inputs]
    clone[index] = e.target.value
    setInputs(clone)
  }
  
  function makeChoice() {
    if (inputs[0].length > 1 && inputs.length >= 2) {
      let number = Math.floor(Math.random() * inputs.length)
      if (inputs[number].length != 0) {
        setChoice(number)
      } else {
        display('Please fill in all the inputs')
        makeChoice()
      }
    } else {
      display('Please fill at least two inputs')
    }
  }

  function display(msgText) {
    setMsg(msg = msgText)
    setTimeout(() => {setMsg('')}, 3000)
  }

  function handleDelete(index) {
    let clone = [...inputs]
    clone.splice(index, 1)
    setInputs(clone)
  }

  function handleAdd() {
    setInputs([...inputs, ''])
  }

  return (
    <AnimatePresence exitBeforeEnter>
      <Nav />

      <div className="main">

        <div className="list">
          <h2>Option list</h2>
          <form>
            {inputs.map((one, index) => <motion.div className="form-block" initial={{ opacity: 0, height: 0, y: '-100%'}} animate={{ opacity: 1, height: '', y: 0}}exit={{ opacity: 0, y: '-100%'}} key={index} >
                <label htmlFor="">Option {index + 1}</label>
                <input type="text" placeholder="Enter your option" value={inputs[index]} onChange={e => handleChange(e, index)}/>
                {inputs.length > 1 && <motion.div className="t" onClick={e => handleDelete(index)}>Delete</motion.div>}
              </motion.div>
            )}

            <span className="btn" onClick={handleAdd}>Add input</span>
            {/* <button type="submit" className="btn">Submit</button> */}
          </form>
        </div>

        <div className="add">
          <h2>Choose</h2>
          <div className="text">{inputs[choice]}</div>
          {msg.length > 1 && <motion.div className="msg" initial={{ opacity: 0, height: 0, y: '-100%'}} animate={{ opacity: 1, height: '', y: 0}} exit={{ opacity: 0, y: '-100%'}}>{msg}</motion.div>}
          <button className="choose" onClick={makeChoice}>Choose</button>
        </div>
      </div>
    </AnimatePresence>
  )
}

export default App
